export default {
	list: 'BuyoutProgramDetail',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			editable: false
		},
		Status: {
			class: 'value',
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 150,
			hidden: true,
			editable: false
		},
		WorkflowStatus: {
			class: 'choice',
			dataName: 'WorkflowStatus',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: false,
			readOnly: true
		},
		Treasury: {
			class: 'lookup',
			dataName: 'Treasury',
			type: 'dropdown',
			dropdown: true,
			title: 'Converted To Treasury',
			source: 'ConvertToTreasuryOptions',
			width: 200,
			hidden: false,
		},
		PartnerName: {
			class: 'value',
			dataName: 'PartnerName',
			type: 'string',
			title: 'Partner Name',
			width: 100,
			hidden: true,
			editable: false,
		},
		PartnerId: {
			class: 'value',
			dataName: 'PartnerId',
			type: 'string',
			title: 'Partner Id',
			width: 100,
			hidden: true,
			editable: false,
		},
		PartnerLeaveDate: {
			class: 'value',
			dataName: 'PartnerLeaveDate',
			type: 'date',
			title: 'Partner Leave Date',
			width: 100,
			hidden: true,
			readOnly: true
		},
		ProgramId: {
			class: 'value',
			dataName: 'ProgramId',
			type: 'string',
			title: 'Program Id',
			width: 150,
			hidden: true,
			editable: false,
		},
		ProgramName: {
			class: 'value',
			dataName: 'ProgramName',
			type: 'string',
			title: 'Program Name',
			width: 230,
			hidden: false,
			editable: false,
		},
		UnitPool: {
			class: 'choice',
			dataName: 'UnitPool',
			type: 'string',
			title: 'Unit Pool',
			width: 185,
			hidden: false,
			editable: false,
			editable: false
		},
		UnitType: {
			class: 'choice',
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 185,
			hidden: false,
			editable: false
		},
		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 185,
			hidden: false,
			editable: false
		},
		UnitPrice: {
			class: 'value',
			dataName: 'UnitPrice',
			type: 'currency',
			title: 'Unit Price',
			template: '<span class="number-cell-ui">#=kendo.format("{0:c}", UnitPrice!=null?UnitPrice:0 )#</span>',
			width: 185,
			hidden: false,
			editable: false
		},
		AwardedUnits: {
			class: "value",
			dataName: 'AwardedUnits',
			type: 'number',
			title: 'Awarded Units',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", AwardedUnits!=null?AwardedUnits:0 )#</span>',
			width: 215,
			hidden: false,
			editable: false
		},
		VestedUnits: {
			class: "value",
			dataName: 'VestedUnits',
			type: 'number',
			title: 'Vested Units',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", VestedUnits!=null?VestedUnits :0 ) #</span>',
			width: 205,
			hidden: false,
			editable: false
		},
		VestPercentage: {
			class: 'value',
			dataName: 'VestPercentage',
			type: 'number',
			title: 'Vested %',
			template: '<span class="number-cell-ui">#=kendo.format("{0:p}", VestPercentage!=null?VestPercentage:0)#</span>',
			width: 185,
			hidden: false,
			editable: false
		},
		UnitsToBeRetained: {
			class: "value",
			dataName: 'UnitsToBeRetained',
			type: 'number',
			title: 'Additional Units to be Retained',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", UnitsToBeRetained!=null?UnitsToBeRetained:0 )#</span>',
			width: 310,
			hidden: false,
			validation: { min: 0 },
		},
		TotalUnitsToBeRetained: {
			class: "value",
			dataName: 'TotalUnitsToBeRetained',
			type: 'number',
			title: 'Total Units To Be Retained',
			width: 290,
			hidden: false,
			editable: false,
			template: "<span class='TotalUnitsToBeRetained number-cell-ui'>#= kendo.format('{0:n2}',TotalUnitsToBeRetained!=null?TotalUnitsToBeRetained:0) #</span>" //#= VestedUnits + UnitsToBeRetained #
		},
		UnitsToBeForfeited: {
			class: "value",
			dataName: 'UnitsToBeForfeited',
			type: 'number',
			title: 'Units To Be Forfeited',
			width: 250,
			hidden: false,
			editable: false,
			template: "<span class='UnitsToBeForfeited number-cell-ui'>#=kendo.format('{0:n2}', UnitsToBeForfeited!=null?UnitsToBeForfeited:0)#</span>" //#= AwardedUnits - TotalUnitsToBeRetained #
		},
		SumofAwardedUnits: {
			class: "value",
			dataName: 'SumofAwardedUnits',
			type: 'number',
			title: 'Sum of Awarded Units',
			width: 100,
			hidden: true,
			editable: false,
		},
		AmountPaidForProgram: {
			class: "value",
			dataName: 'AmountPaidForProgram',
			type: 'currency',
			title: 'Amount Paid For Program',
			template: '<span class="number-cell-ui">#=kendo.toString(AmountPaidForProgram, "c")#</span>',
			width: 175,
			hidden: true,
			editable: false,
		},
		AmountPaid: {
			class: "value",
			dataName: 'AmountPaid',
			type: 'currency',
			title: 'Amount Paid for Units',
			template: "<span class='AmountPaid number-cell-ui'>#=kendo.toString(AmountPaid, 'c')#</span>", //#= AwardedUnits - TotalUnitsToBeRetained #
			width: 220,
			hidden: false,
			editable: false,
		},
		AmountPayable: {
			class: "value",
			dataName: 'AmountPayable',
			type: 'currency',
			title: 'Amount Payable to Partner',
			width: 290,
			hidden: false,
			editable: false,
			template: "<span class='AmountPayable number-cell-ui'>#= kendo.toString(UnitPrice * TotalUnitsToBeRetained, 'c') #</span>"
		},
		AmountReceivable: {
			class: "value",
			dataName: 'AmountReceivable',
			type: 'currency',
			title: 'Amount Receivable from Partner',
			width: 290,
			hidden: false,
			editable: false,
			template: "<span class='AmountReceivable number-cell-ui'>#= kendo.toString(UnitPrice * (AwardedUnits - TotalUnitsToBeRetained), 'c') #</span>"
		},
		Buyout: {
			class: "value",
			dataName: 'Buyout',
			type: 'currency',
			title: 'Buyout',
			width: 190,
			hidden: false,
			editable: false,
			template: "<span class='Buyout number-cell-ui'>#= kendo.toString(Buyout, 'c') #</span>" //#= AmountPaid - AmountPayable #
		},
		AmountOwedToPartnership: {
			class: "value",
			dataName: 'AmountOwedToPartnership',
			type: 'currency',
			title: 'Amount Owed To Partnership',
			width: 320,
			hidden: false,
			editable: false,
			template: "<span class='AmountOwedToPartnership number-cell-ui'>#= kendo.toString(AmountOwedToPartnership, 'c') #</span>" //#= AmountPayable - AmountPaid #
		},
		ContributionRelief: {
			class: "value",
			dataName: 'ContributionRelief',
			type: 'currency',
			title: 'Contribution Relief',
			width: 250,
			hidden: false,
			editable: false,
			template: "<span class='ContributionRelief number-cell-ui'>#= kendo.toString(ContributionRelief, 'c') #</span>" //AmountReceivable - Buyout
		},
		NetPayout: {
			class: "value",
			dataName: 'NetPayout',
			type: 'currency',
			title: 'Net Payout',
			width: 210,
			hidden: false,
			editable: false,
			template: "<span class='NetPayout number-cell-ui'>#= kendo.toString(NetPayout, 'c') #</span>" //#= Buyout - AmountOwedToPartnership #
		},
		VestingType: {
			class: 'value',
			dataName: 'VestingType',
			type: 'string',
			title: 'Vesting Type',
			width: 350,
			hidden: true,
			readOnly: false,
		},

	}
}